import { listFormDefinitions } from '../../../util/APIUtils';

/** @type {unknown[] | null} */
let cachedRows = null;

/** @type {Promise<unknown[]> | null} */
let inflightRequest = null;

/**
 * Returns the cached list if the GET has already completed successfully.
 * @returns {unknown[] | null}
 */
export function peekFormDefinitionsCache() {
  return cachedRows;
}

/**
 * Clears the in-memory cache (e.g. after logout). Optional; list is session-scoped.
 */
export function clearFormDefinitionsCache() {
  cachedRows = null;
  inflightRequest = null;
}

function readWrappedRows(data) {
  return data.data ?? data.forms ?? data.items;
}

function normalizeToArray(data) {
  if (Array.isArray(data)) {
    return data;
  }
  const inner = data && typeof data === 'object' ? readWrappedRows(data) : null;
  return Array.isArray(inner) ? inner : [];
}

/**
 * GET /api/content/form (portal) with deduplication and in-memory caching for the session.
 * Concurrent callers share one in-flight request; after success, subsequent calls resolve from cache without HTTP.
 * @param {{ force?: boolean }} [options] — When `force: true`, skips cache and in-flight reuse and performs a new GET.
 * @returns {Promise<unknown[]>}
 */
export function getFormDefinitionsListCached(options = {}) {
  const force = Boolean(options.force);
  if (force) {
    cachedRows = null;
    inflightRequest = null;
  }
  if (cachedRows !== null) {
    return Promise.resolve(cachedRows);
  }
  if (inflightRequest !== null) {
    return inflightRequest;
  }
  inflightRequest = listFormDefinitions()
    .then((response) => {
      const rows = normalizeToArray(response);
      cachedRows = rows;
      inflightRequest = null;
      return cachedRows;
    })
    .catch((err) => {
      inflightRequest = null;
      throw err;
    });
  return inflightRequest;
}
